import React from 'react'

export function search() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" style={{enableBackground: "new 0 0 17 18", fill: 'red'}} xmlSpace="preserve">
      <path className="stroke" fill="none" fillRule="evenodd" strokeLinecap="round" strokeWidth="1.5" d="M11.93 12.603L16.2 17M14.03 7.44c0 3.556-2.916 6.439-6.515 6.439C3.917 13.879 1 10.996 1 7.439 1 3.883 3.917 1 7.515 1c3.599 0 6.516 2.883 6.516 6.44z"/>
    </svg>
  )
}
